import { JOBS_RETRIED_EVENT } from "../../types";
import { request as utilsRequest } from "../../utils";
import { locationRestJobsRetryPost } from "../../wp-api";
import { fetchStatus } from "..";
/**
 * Retry jobs by e.g. type. This is similar to a "Cancel" button.
 */ async function retryJobs(request) {
    const response = await utilsRequest({
        location: locationRestJobsRetryPost,
        request
    });
    document.dispatchEvent(new CustomEvent(JOBS_RETRIED_EVENT, {
        detail: {
            request,
            response
        }
    }));
    await fetchStatus(true);
}
export { retryJobs };
